import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

export const dynamicSearch = {
  componentType: AdPlacementsComponentTypes.AdPlacementDynamicSearch,
  key: 'dynamic_search',
  className: 'dynamic_search',
  type: 'DynamicSearchAd',
  associationType: 'DynamicSearchAd',
  localizedText: {
    previewTypeStringKey: _TL_('Dynamic search ad'),
    stringKey: _TL_(''),
  },
  previewSettings: {},
  styleOverrides: {},
};
